import { render, staticRenderFns } from "./contractReletForm.vue?vue&type=template&id=53f6a0f4&scoped=true"
import script from "./contractReletForm.vue?vue&type=script&lang=js"
export * from "./contractReletForm.vue?vue&type=script&lang=js"
import style0 from "./contractReletForm.vue?vue&type=style&index=0&id=53f6a0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f6a0f4",
  null
  
)

export default component.exports